import {useMemo} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {ISitemapRegionListRegion} from "../actions/fetch_site_map_region";
import {ISelectedRegionList} from "../interfaces/ISelectedRegionList";

const buildRegionObj = (
    voivodeships: ISitemapRegionListRegion[],
    aggregations: ISitemapRegionListRegion[],
    counties: ISitemapRegionListRegion[],
    cities: ISitemapRegionListRegion[]
) => {
    const domesticRegions = voivodeships.filter((voivodeship) => voivodeship.id <= 1000);
    const abroadRegions = voivodeships.filter((voivodeship) => voivodeship.id > 1000);

    const selectedRegion = domesticRegions.reduce((acc, voivodeship) => {
        const filteredAggregations = aggregations.filter((aggregation) => aggregation.stats?.family?.voivodeship === voivodeship.name);
        const filteredCounties = counties.filter((county) => county.stats?.family?.voivodeship === voivodeship.name);
        const filteredCities = cities.filter((city) => city.stats?.family?.voivodeship === voivodeship.name);
        return [
            ...acc,
            {
                ...voivodeship,
                aggregations: filteredAggregations,
                counties: filteredCounties,
                cities: filteredCities
            }
        ];
    }, [] as ISelectedRegionList[]);

    const abroadRegionList = abroadRegions.map((voivodeship) => ({
        ...voivodeship,
        aggregations: aggregations.filter((aggregation) => aggregation.stats?.family?.voivodeship === voivodeship.name),
        counties: counties.filter((county) => county.stats?.family?.voivodeship === voivodeship.name),
        cities: cities.filter((city) => city.stats?.family?.voivodeship === voivodeship.name)
    }));

    return {
        domesticRegions: selectedRegion,
        abroadRegions: abroadRegionList
    };
};

export const useRegions = () => {
    const storeRegions = useSelector((state: IRPStore) => state.siteMap.regions);

    return useMemo(
        () =>
            buildRegionObj(
                storeRegions.voivodeship as ISitemapRegionListRegion[],
                storeRegions.aggregation as ISitemapRegionListRegion[],
                storeRegions.county as ISitemapRegionListRegion[],
                storeRegions.city as ISitemapRegionListRegion[]
            ),
        [storeRegions]
    );
};
import {useMemo} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {ISitemapRegionListRegion} from "../actions/fetch_site_map_region";
import {ISelectedRegionList} from "../interfaces/ISelectedRegionList";

const buildRegionObj = (
    voivodeships: ISitemapRegionListRegion[],
    aggregations: ISitemapRegionListRegion[],
    counties: ISitemapRegionListRegion[],
    cities: ISitemapRegionListRegion[]
) => {
    const domesticRegions = voivodeships.filter((voivodeship) => voivodeship.id <= 1000);
    const abroadRegions = voivodeships.filter((voivodeship) => voivodeship.id > 1000);

    const selectedRegion = domesticRegions.reduce((acc, voivodeship) => {
        const filteredAggregations = aggregations.filter((aggregation) => aggregation.stats?.family?.voivodeship === voivodeship.name);
        const filteredCounties = counties.filter((county) => county.stats?.family?.voivodeship === voivodeship.name);
        const filteredCities = cities.filter((city) => city.stats?.family?.voivodeship === voivodeship.name);
        return [
            ...acc,
            {
                ...voivodeship,
                aggregations: filteredAggregations,
                counties: filteredCounties,
                cities: filteredCities
            }
        ];
    }, [] as ISelectedRegionList[]);

    const abroadRegionList = abroadRegions.map((voivodeship) => ({
        ...voivodeship,
        aggregations: aggregations.filter((aggregation) => aggregation.stats?.family?.voivodeship === voivodeship.name),
        counties: counties.filter((county) => county.stats?.family?.voivodeship === voivodeship.name),
        cities: cities.filter((city) => city.stats?.family?.voivodeship === voivodeship.name)
    }));

    return {
        domesticRegions: selectedRegion,
        abroadRegions: abroadRegionList
    };
};

export const useRegions = () => {
    const storeRegions = useSelector((state: IRPStore) => state.siteMap.regions);

    return useMemo(
        () =>
            buildRegionObj(
                storeRegions.voivodeship as ISitemapRegionListRegion[],
                storeRegions.aggregation as ISitemapRegionListRegion[],
                storeRegions.county as ISitemapRegionListRegion[],
                storeRegions.city as ISitemapRegionListRegion[]
            ),
        [storeRegions]
    );
};
